import { render, staticRenderFns } from "./PreviewSinglechoiceModule.vue?vue&type=template&id=f9393498&scoped=true&"
import script from "./PreviewSinglechoiceModule.vue?vue&type=script&lang=js&"
export * from "./PreviewSinglechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSinglechoiceModule.vue?vue&type=style&index=0&id=f9393498&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9393498",
  null
  
)

export default component.exports